import { useEffect, useRef } from "react";

export const useEventListener = <K extends keyof WindowEventMap>(
  eventName: K,
  handler: (_?: any) => void,
  element = window
) => {
  const savedHandler = useRef<any>();

  useEffect(() => {
    savedHandler.current = handler;
  }, [handler]);

  useEffect(() => {
    const isSupported = element && element.addEventListener;

    if (!isSupported) {
      return;
    }

    const eventListener = (event: WindowEventMap[K]) =>
      savedHandler.current(event);

    element.addEventListener(eventName, eventListener);

    return () => {
      element.removeEventListener(eventName, eventListener);
    };
  }, [eventName, element]);
};
